module.exports = __webpack_public_path__ + "img/aleve_pain_reliever_fever_reducer_caplets.936e5c43.png";